<mat-form-field class="chip-list w-100" appearance="fill">
  <mat-label class="form-title">{{ label ||  'Content Tags'  }} </mat-label>
  <mat-chip-grid
    [disabled]="disabled"
    #chipList
    aria-label="Tag selection"
    data-testId="edit-content-media-chip-list"
  >
    <ng-container
      *ngIf="!disabled"
    >
      <mat-chip
        data-testid="content-tags-form-field-tag-chip"
        class="chip"
        *ngFor="let tag of tags"
        (removed)="remove(tag)"
        [class.duplicate]="duplicatedTagNames !== null ? duplicatedTagNames.includes(tag.name) : false"
      >
        {{ tag.name }}
        <button data-testid="content-tags-form-field-remove-tag-button" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </ng-container>
    <input #tagInput data-testid="content-tags-form-field-tag-input" [placeholder]="placeholder || 'Add Tag...'" [formControl]="value"
      [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputFor]="chipList"
      (matChipInputTokenEnd)="onAddTagEvent($event)" />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectAutoCompletionTag($event)">
    <mat-option style="color: var(--iptv-brand-green)" *ngFor="let tag of autoCompletionTags | async" [value]="tag">
      {{ tag.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>